module.exports = __webpack_public_path__ + "images/emails/bg-envelope-r-c0ac5e1c.png";